import { css, cva } from '@lastbrand/web-ui-styled-system/css'

/**
 * Shared option-box border treatment, used by the text / image / pack option boxes.
 *
 * base = default 1px box border (legacy $border-black, black @20% — no alpha token).
 * The `input:checked + &, input:focus-visible + &` darken-to-black is in `base` so the
 * radio-driven boxes (text, image) get it for free; pack has no preceding radio sibling
 * (it is a display-only Button) so it opts into the same darken via the JS `selected`
 * variant instead. Only the colour darkens on selection — width stays 1px.
 */
export const optionBoxRecipe = cva({
  base: {
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'rgba(33, 32, 31, 0.2)',
    'input:checked + &, input:focus-visible + &': {
      borderColor: 'black',
    },
  },
  variants: {
    selected: {
      true: { borderColor: 'black' },
    },
  },
})

/**
 * Column wrapper around a single swatch + its red dot (legacy `.colorOptionWrapper` /
 * image wrapper): column, centred, no shrink. Shared by the color and image options.
 */
export const optionColumnClass = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  flexShrink: 0,
})

// Legacy `.redDot`: 4px red sale dot below the swatch. Color `$new-site-red` → `red-100`.
// `4px` is a sub-token size kept literal (flagged: no-token); `radius-round` for the circle.
// Shared by the color and image options.
export const redDotClass = css({
  width: '4px',
  height: '4px',
  marginBlock: 'space-2',
  backgroundColor: 'red-100',
  borderRadius: 'radius-round',
  // Chrome subpixel anti-aliasing fix carried over from legacy.
  transform: 'translateZ(0)',
  willChange: 'transform',
})
